import React, { useCallback, useEffect, useState } from "react";

// Translations
import { useTranslation } from "react-i18next";

// Material UI
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

// Types
import { APIId, Note } from "../../../../../../../../types";

// Utils
import * as urls from "../../../../../../../../utils/urls";

interface OverviewModalProps {
  noteId?: APIId;
  open: boolean;
  onClose: () => void;
}

// TODO: Remove default from noteId
const OverviewModal: React.FC<OverviewModalProps> = ({ noteId = 10, open, onClose }) => {
  // Translations
  const { t } = useTranslation();

  // State
  const [smartNote, setSmartNote] = useState<Note | null>(null);

  // Methods
  const loadSmartNote = useCallback(async () => {
    const options = {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
    };

    const response = await fetch(urls.noteUrl(noteId), options);
    if (response.ok) {
      const data = await response.json();
      setSmartNote(data.data.attributes);
    }
  }, [noteId]);

  useEffect(() => {
    if (open && noteId) loadSmartNote();
  }, [open, noteId]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        {t('courses.new.structure.overview')}
      </DialogTitle>

      <DialogContent>
        <Typography variant="h6">
          {smartNote?.title}
        </Typography>

        <div dangerouslySetInnerHTML={{ __html: smartNote?.content || '' }} />
      </DialogContent>

      <DialogActions>
        <Button variant="contained" color="primary" onClick={onClose}>
          {t('globals.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OverviewModal;
